import React, { useState, useEffect } from 'react';

const Navigation: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`topbar${scrolled ? ' scrolled' : ''}`}>
      <div className="topbar-inner">
        <button
          className="topbar-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          Carlos Matecki
        </button>
        <div className="topbar-right">
          <a
            href="https://github.com/Carcodee"
            target="_blank"
            rel="noopener noreferrer"
            className="topbar-btn"
          >
            GitHub ↗
          </a>
          <a
            href="https://www.linkedin.com/in/carlosmatecki/"
            target="_blank"
            rel="noopener noreferrer"
            className="topbar-btn"
          >
            LinkedIn ↗
          </a>
          <a
            href="/Carlos_Matecki_Resume.pdf"
            download
            className="topbar-btn topbar-btn-primary"
          >
            Resume ↓
          </a>
        </div>
      </div>
    </header>
  );
};

export default Navigation;
